import { z } from 'zod';

import { StaffingDtoScheme } from '~modules/staffing/dto';

export const LimitDtoSchema = z.object({
	id: z.number().describe('Идентификатор').nullable().optional(),
	staffing_id: z.number().describe('Идентификатор штатки'),
	staffing: StaffingDtoScheme.describe('Штатка').nullable().optional(),
	section_id: z.number().describe('Идентфикатор участка'),
	full_time_work: z.number().describe('Количество часов'),
	overtime: z.number().describe('Процент от штатной работы по переработке'),
	part_time_job: z.number().describe('Процент от штатной работы по подработке'),
});

export type LimitDto = z.infer<typeof LimitDtoSchema>;

export const LimitUpdateDtoSchema = z.object({
	position_id: z.string().describe('Идентификатор должности'),
	full_time_work: z.number().describe('Количество часов'),
	overtime: z.number().describe('Процент от штатной работы по переработке'),
	part_time_job: z.number().describe('Процент от штатной работы по подработке'),
});

export type LimitUpdateDto = z.infer<typeof LimitUpdateDtoSchema>;
